var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 4.083v4.667a1.167 1.167 0 001.167 1.167h3.5M4.667 4.083V2.917a1.167 1.167 0 011.167-1.167h2.675a0.583 0.583 0 01.413.171l2.575 2.575a0.583 0.583 0 01.171.413V8.75a1.167 1.167 0 01-1.167 1.167h-1.167M4.667 4.083H3.5a1.167 1.167 0 00-1.167 1.167v5.833a1.167 1.167 0 001.167 1.167h4.667a1.167 1.167 0 001.167-1.167v-1.167",
    stroke: "#3F3F46",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDuplicate);
export default __webpack_public_path__ + "static/media/document-duplicate.7859c762ade74554af6c2155b5a7127b.svg";
export { ForwardRef as ReactComponent };